// components/ContactSection.jsx
import React, { useState } from "react";
import "./Sections.css";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import backend from "../../../../../api";
import { useSnackbar } from "notistack";
import { CircularProgress } from "@mui/material";

function ContactSection() {
  const { enqueueSnackbar } = useSnackbar();

  const [formData, setFormData] = useState({
    email: "",
    name: "",
    message: "",
  });

  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const email = formData.email?.trim();
    const name = formData.name?.trim();
    const message = formData.message?.trim();

    if (!email || !name || !message) {
      enqueueSnackbar("Please fill in all fields.", { variant: "warning" });
      return;
    }

    const body = {
      fullname: name,
      email,
      message,
    };

    try {
      setSubmitting(true);
      const res = await backend.post("/api/contact", body);

      if (res?.status === 200) {
        enqueueSnackbar("Email sent successfully!", {
          variant: "success",
        });
        // clear form
        setFormData({ email: "", name: "", message: "" });
      } else {
        enqueueSnackbar("Something went wrong while sending the email.", {
          variant: "error",
        });
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Something went wrong while sending the email.", {
        variant: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="section section-alt" id="contact">
      <div className="section-inner">
        <div className="contact-wrapper">
          <div className="contact-illustration">
            <div className="contact-illustration-box">
              {/* <div className="contact-illustration-inner" /> */}
               {/* <h2 className="section-title">Contact Us</h2> */}
            <p className="section-subtitle contact-form-description">
              Connect with us and be part of this mission. If you&apos;d like to
              share feedback, ideas, or explore how you can support Tawaf&apos;s
              work, we&apos;d be honoured to hear from you.
            </p>
            </div>
          </div>

          <div>
           

            <form className="contact-form" onSubmit={handleSubmit}>
              <h3 className="contact-form-title">Send us a message</h3>
              <p className="contact-form-description">
                We usually respond within 1–2 working days.
              </p>

              <div className="contact-form-group">
                <label className="contact-form-label">Your email</label>
                <input
                  type="email"
                  className="contact-input"
                  placeholder="you@example.com"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={submitting}
                />
              </div>

              <div className="contact-form-group">
                <label className="contact-form-label">Name</label>
                <input
                  type="text"
                  className="contact-input"
                  placeholder="Your full name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  disabled={submitting}
                />
              </div>

              <div className="contact-form-group">
                <label className="contact-form-label">Message</label>
                <textarea
                  className="contact-textarea"
                  placeholder="Share your question, feedback or idea..."
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  disabled={submitting}
                />
              </div>

              <button
                type="submit"
                className="btn-primary"
                disabled={submitting}
              >
                {submitting ? (
                  <>
                    Sending…
                    <CircularProgress
                      size={16}
                      style={{ marginLeft: 8, color: "#1f2937" }}
                    />
                  </>
                ) : (
                  <>
                    Get in touch
                    <SendRoundedIcon fontSize="small" />
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
